/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_A1Inputs */

const en_pc_dl_faq_a1 = /** @type {(inputs: Pc_Dl_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most PCs need the x64 installer (.msi). Snapdragon and other ARM laptops need the ARM64 build, and old 32-bit Windows needs x86. Each one also comes as a portable .zip.`)
};

const zh_pc_dl_faq_a1 = /** @type {(inputs: Pc_Dl_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大多数电脑需要 x64 安装包（.msi）。骁龙等 ARM 笔记本需要 ARM64 版本，老旧的 32 位 Windows 需要 x86 版本。每种版本都另有便携 .zip。`)
};

/**
* | output |
* | --- |
* | "Most PCs need the x64 installer (.msi). Snapdragon and other ARM laptops need the ARM64 build, and old 32-bit Windows needs x86. Each one also comes as a por..." |
*
* @param {Pc_Dl_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_a1 = /** @type {((inputs?: Pc_Dl_Faq_A1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_A1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_a1(inputs)
	return zh_pc_dl_faq_a1(inputs)
});
export { pc_dl_faq_a1 as "pc.dl.faq.a1" }